import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'daterange',
    standalone: false
})
export class DateRangePipe implements PipeTransform {
    transform(value: any, endDate?: any): any {
            if(value!=undefined && endDate != undefined)
            {
                let startMonth= moment(value).format('M');
                let endMonth= moment(endDate).format('M');
                if( startMonth == endMonth)
                {
                    value = moment(value).format('MMM D') + " - "+ moment(endDate).format('D, YYYY');
                } else{
                    value = moment(value).format('MMM D') + " - "+moment(endDate).format('MMM D, YYYY');
                }
            }
            return value;
    }
}